<template>
    <div class="void-document-popup">
        <div v-if="element.type ==='edit-document'" class="edit-document">
            <p class="first-paregraph">In order to protect the recipients, if you wish to make any edits on the document you must void it first.</p>
            <p> A voided document is sent back to the status of draft where you can make any modifications needed.</p>
        </div>
        <div v-if="element.type ==='edit-recipient'" class="edit-recipient">
            <p class="first-paregraph">You must first void the document in order to edit a recipient's info. A voided document is sent back to the status of draft where you can make any modifications needed.</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'void-document-popup',

    props:{
        element:{
            type: Object,
            required: true
        }
    }
}
</script>

<style>
.void-document-popup .first-paregraph{
    margin-bottom: 40px;
}
</style>